import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function CallbackListQuery() {
  const { data } = useQuery({
    queryKey: ["callbackListStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["CallbackListStats"]>(
        "/api/Reports/CallbackListStats",
      );
      return response.data;
    },
  });

  return {
    totalCount: data?.totalOpenCallbacks,
    todaysCallbacks: data?.todaysCallbacks ?? [],
    missedCallbacks: data?.missedCallbacks ?? [],
  };
}
